import { render } from "./Variants.vue?vue&type=template&id=0aed9d6e"
import script from "./Variants.vue?vue&type=script&lang=js"
export * from "./Variants.vue?vue&type=script&lang=js"

const cssModules = script.__cssModules = {}
import style0 from "./Variants.vue?vue&type=style&index=0&id=0aed9d6e&lang=scss&module=true"
cssModules["$style"] = style0
script.render = render

export default script